// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"5953e81d","223":"dea0384d","332":"71dfeaeb","475":"c6be9ae6","834":"ff96f46b"}[chunkId] + ".chunk.js";
};